import { AxiosError } from 'axios';
import { useAuth } from 'lib/auth';
import { useGet } from 'lib/swr-crud';
import { APIErrorResponse } from 'lib/utils';
import { getUnlockablePerks } from './api';
import { UnlockablePerksResponse } from './types';

export const useUnlockablePerks = ({
  isAllowToFetch = true,
}: {
  isAllowToFetch?: boolean;
} = {}) => {
  const { session, loading } = useAuth();

  const userId = session?.user?.userId;
  const shouldFetch =
    !loading && userId !== undefined && isAllowToFetch;

  const { data, error, isLoading, mutate } = useGet<
    UnlockablePerksResponse,
    AxiosError<APIErrorResponse>
  >(
    shouldFetch ? `/users/${userId}/unlockable_perks` : null,
    async () => await getUnlockablePerks(userId as string),
  );

  const totalUnlockable = data?.data?.total_unlockable ?? 0;
  const totalUnlocked = data?.data?.total_unlocked ?? 0;
  const nextUnlockable = data?.data?.next_unlockable ?? null;

  return {
    totalUnlockable,
    nextUnlockable,
    totalUnlocked,
    error,
    isLoading: isLoading || loading,
    mutate,
  };
};
